import { useLocalize } from '@treams/treams-hooks/useLocalize';
import * as graphql from '@treams/treams-network';
import { FlexGap } from '@treams/treams-ui/common/FlexGap';
import { Paragraph } from '@treams/treams-ui/common/Text';
import { tokens } from '@treams/treams-ui/theme/tokens';

export default function MultipleChoiceDisplay(props: {
	item: graphql.EvaluationMultipleChoiceItem;
	indices?: Array<number | null> | null;
}) {
	const { localize } = useLocalize();
	const labels = (props.indices ?? [])
		.filter((index): index is number => index != null)
		.sort((left, right) => left - right)
		.map((index) => {
			const text = props.item.options[index]?.text;
			return {
				index,
				label: text ? localize(text).text : '',
			};
		})
		.filter((option) => option.label);

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.element}>
			{labels.map((option) => (
				<Paragraph key={option.index}>{option.label}</Paragraph>
			))}
		</FlexGap>
	);
}
